import { render, staticRenderFns } from "./TransferInvoice.vue?vue&type=template&id=8e8acc5a&scoped=true&"
import script from "./TransferInvoice.vue?vue&type=script&lang=js&"
export * from "./TransferInvoice.vue?vue&type=script&lang=js&"
import style0 from "./TransferInvoice.vue?vue&type=style&index=0&id=8e8acc5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8acc5a",
  null
  
)

export default component.exports